/* eslint-disable no-unused-vars */
const CAKES = 'cakes';
const DRINKS = 'drinks';
const QUICHES = 'quiches';
const BRUNCHES = 'brunches';
const DESSERTS = 'desserts';
const ICECREAM = 'icecream';
const GALLERY = 'gallery';
const ABOUT = 'about';

export const navigationLeft = [CAKES, QUICHES, DESSERTS];
export const navigationRight = [BRUNCHES, GALLERY, ABOUT];

export const availableProducts = [CAKES, QUICHES, DESSERTS, BRUNCHES];
